<template slot-scope="scope">
  <!-- 发票信息管理 组件 -->
  <div class="box">
    <div class="main-body" v-for="(item, index) in TheTotal" :key="index">
      <!-- 头部 -->
      <div class="head">
        <p class="head-title">{{ item.title }}</p>
        <p class="head-remark">
          {{ item.annotation }}
        </p>
        <div class="btn-body">
          <p class="firm-clickable" @click="handelClickAppend(item)">添加</p>
        </div>
      </div>
      <!-- 主体表格 -->
      <div class="table">
        <div class="header">
          <p v-for="(item, index) in item.listArr" :key="index">
            {{ item }}
          </p>
        </div>
        <div
          class="tabulation"
          v-for="(item1, index) in item.dataArr"
          :key="index"
        >
          <p v-if="item.id == 1">{{ item1.headName }}</p>
          <p v-if="item.id == 2">{{ item1.address }}</p>
          <p v-if="item.id == 3">{{ item1.mail }}</p>
          <p v-if="item.id == 1">
            {{ item1.invoiceType == 0 ? "增值税普通发票" : "增值税专用发票" }}
          </p>
          <p v-if="item.id == 2">{{ item1.phone }}</p>
          <p v-if="item.id == 1">{{ item1.headType == 0 ? "个人" : "企业" }}</p>

          <div>
            <span
              v-if="item1.headType != 0"
              class="span-one firm-clickable"
              @click="handelClickEdit(item, item1)"
              >编辑</span
            >
            <span
              v-if="item1.headType != 0"
              class="span-tw firm-clickable"
              @click="handelClickDelete(item, item1)"
              >删除</span
            >
            <span
              v-if="item1.defaultFlag != '1'"
              class="span-th firm-clickable"
              @click="handelClickAcquiesce(item, item1)"
              >设置默认</span
            >
          </div>
        </div>
      </div>
      <!-- 底部数量 -->
      <div class="quantity">
        <p>{{ item.dataArr.length }}/{{ item.number }}</p>
      </div>
    </div>
    <!-- 添加邮箱添加地址编辑邮箱地址删除设置默认弹窗 -->
    <incidentWindow
      :dialogIncident="dialogIncident"
      :Toggle="Toggle"
      :moduleTitle="moduleTitle"
      :inputEcho="inputEcho"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></incidentWindow>
  </div>
</template>

<script>
// 引入接口
import {
  addInvoiceMail, //添加邮箱地址
  editInvoiceMail, //编辑发票邮箱地址
  deleteInvoiceMail, //删除发票邮箱地址
  setDefaultInvoiceMail, //设置默认发票邮箱
  addInvoiceAddress, //添加发票邮寄地址
  editInvoiceAddress, //编辑发票邮寄地址
  deleteInvoiceAddress, //删除发票邮寄地址
  setDefaultInvoiceAddress, //设置默认发票地址
  addInvoiceHead, //新增发票抬头
  editInvoiceHead, //编辑发票抬头
  deleteInvoiceHead, //删除发票抬头
  setDefaultInvoiceHead, //设置默认发票抬头
} from "../../../../../../assets/api/CenterInvoice";
// 引入发票信息管理页面的 功能弹窗
import incidentWindow from "./incidentWindow.vue";
export default {
  props: {
    dialogVisible: {},
    dataMsg: {},
    num: {},
  },
  components: {
    incidentWindow,
  },
  data() {
    return {
      TheTotal: [
        {
          id: "1",
          title: "发票抬头信息",
          number: "6",
          annotation:
            "（个人申请，需实名认证，且发票类型不可更改，最多添加6条）",
          listArr: ["发票抬头", "发票类型", "抬头类型", "操作"],
          dataArr: [],
        },
        {
          id: "2",
          title: "邮寄地址",
          number: "12",
          annotation: "（最多添加12条）",
          listArr: ["地址", "电话", "操作"],
          dataArr: [],
        },
        {
          id: "3",
          title: "电子邮箱",
          number: "12",
          annotation: "（最多添加12条）",
          listArr: ["邮箱", "操作"],
          dataArr: [],
        },
      ], //总数组
      dialogIncident: false, // incidentWindow弹窗
      Toggle: "", //切换 ， 1.添加地址 2.添加邮箱 3.编辑地址 4.编辑邮箱 5.删除地址 6.删除邮箱 7.地址设为默认 8.邮箱设为默认 9.添加发票抬头 10.编辑发票抬头 11.删除发票抬头 12.发票抬头设为默认
      moduleTitle: "", //传给组件的标题
      inputEcho: "", //编辑数据回显
      rowId: "", // 被点击项的id用于传参数
    };
  },
  watch: {
    // 监听
    dataMsg: {
      handler(newss, old) {
        console.log(newss, "newss");
        this.TheTotal[0].dataArr = newss.headList;
        this.TheTotal[1].dataArr = newss.addressList;
        this.TheTotal[2].dataArr = newss.mailList;
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    // 点击设置默认 打开弹窗
    handelClickAcquiesce(item, item1) {
      this.rowId = item1.id;
      let confirmMessage = '';
      
      if (item.id == 1) {
        // 设置默认发票抬头信息
        confirmMessage = '确定要将此发票抬头设为默认吗？';
      } else if (item.id == 2) {
        // 设置默认邮寄地址
        confirmMessage = '确定要将此邮寄地址设为默认吗？';
      } else {
        // 设置默认邮箱
        confirmMessage = '确定要将此邮箱设为默认吗？';
      }
      
      this.$confirmWithScroll(confirmMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户确认后执行设置默认操作
        if (item.id == 1) {
          this.handleUnderstand(12);
        } else if (item.id == 2) {
          this.handleUnderstand(7);
        } else {
          this.handleUnderstand(8);
        }
      }).catch(() => {
        // 用户取消
      });
    },
    // 点击删除
    handelClickDelete(item, item1) {
      this.rowId = item1.id;
      this.$confirmWithScroll("确认删除该条信息?", "提示").then(() => {
        if (item.id == 1) {
          // 删除发票抬头信息
          deleteInvoiceHead({ data: this.rowId }).then((res) => {
            this.resTips(res);
          });
        } else if (item.id == 2) {
          // 删除邮寄地址
          var data = {
            data: {
              id: this.rowId,
            },
          };
          deleteInvoiceAddress(data).then((res) => {
            this.resTips(res);
          });
        } else {
          // 删除邮箱
          var data = {
            data: {
              id: this.rowId,
            },
          };
          deleteInvoiceMail(data).then((res) => {
            this.resTips(res);
          });
        }
      }).catch(() => {});
    },
    //点击编辑
    handelClickEdit(item, item1) {
      this.rowId = item1.id;

      if (item.id == 1) {
        // 编辑发票抬头信息
        this.moduleTitle = "编辑";
        this.Toggle = "10";
        this.inputEcho = JSON.parse(JSON.stringify(item1));
        this.dialogIncident = true;
      } else if (item.id == 2) {
        // 编辑邮寄地址
        this.moduleTitle = "编辑";
        this.Toggle = "3";
        this.inputEcho = JSON.parse(JSON.stringify(item1));
        this.dialogIncident = true;
      } else {
        // 编辑邮箱
        this.moduleTitle = "编辑";
        this.Toggle = "4";
        this.inputEcho = JSON.parse(JSON.stringify(item1));
        this.dialogIncident = true;
      }
    },
    //点击添加按钮
    handelClickAppend(item) {
      if (item.id == 1) {
        // 添加发票抬头信息
        this.moduleTitle = "发票抬头信息";
        this.Toggle = "9";
        this.dialogIncident = true;
      } else if (item.id == 2) {
        // 添加邮寄地址
        this.moduleTitle = "邮寄地址";
        this.Toggle = "1";
        this.dialogIncident = true;
      } else {
        // 添加邮箱
        this.moduleTitle = "电子邮箱";
        this.Toggle = "2";
        this.dialogIncident = true;
      }
    },
    // 关闭添加地址等弹窗
    handleClose(val) {
      //切换 ， 1.添加地址 2.添加邮箱 3.编辑地址 4.编辑邮箱 5.删除地址 6.删除邮箱 7.设为默认
      this.dialogIncident = false;
    },

    // 操作后的提示
    resTips(res) {
      if (res.code == 0) {
        // 补充成功
        this.$tool.PromptBox("success", "操作成功");
        this.$emit("Refresh");
        this.dialogIncident = false;
      } else {
        //失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // 确认添加地址等弹窗
    handleUnderstand(num, val, phone, SelectType) {
      console.log(num, val, SelectType, "45554");
      //切换 ， 1.添加地址 2.添加邮箱 3.编辑地址 4.编辑邮箱 5.删除地址 6.删除邮箱 7.设为默认
      if (num == 1) {
        var data = {
          data: {
            ownerType: 0, //开票主体类型 个人0 企业1
            ownerId: this.$store.getters.getUser.id, //开票主体id
            phone: phone, //电话
            address: val, // 地址
          },
        };
        // 添加地址
        addInvoiceAddress(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 3) {
        var data = {
          data: {
            id: this.rowId, //要编辑项的id
            phone: phone, //电话
            address: val, // 地址
          },
        };
        // 编辑邮寄地址
        editInvoiceAddress(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 5) {
        var data = {
          data: {
            id: this.rowId, //要删除项的id
          },
        };
        // 删除邮寄地址
        deleteInvoiceAddress(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 7) {
        var data = {
          data: {
            id: this.rowId, //要设置默认项的id
            ownerType: 0, //开票主体类型 个人0 企业1
            ownerId: this.$store.getters.getUser.id, //开票主体id
          },
        };
        // 设置默认邮寄地址
        setDefaultInvoiceAddress(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 2) {
        var data = {
          data: {
            mail: val, //邮箱地址
            ownerType: 0, //开票主体类型 个人0 企业1
            ownerId: this.$store.getters.getUser.id, //开票主体id
          },
        };
        // 添加邮箱地址
        addInvoiceMail(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 4) {
        var data = {
          data: {
            mail: val, //邮箱地址
            id: this.rowId,
          },
        };
        // 编辑邮箱地址
        editInvoiceMail(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 6) {
        var data = {
          data: {
            id: this.rowId,
          },
        };
        // 删除邮箱地址
        deleteInvoiceMail(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 8) {
        var data = {
          data: {
            id: this.rowId,
            ownerType: 0, //开票主体类型 个人0 企业1
            ownerId: this.$store.getters.getUser.id, //开票主体id
          },
        };
        // 设置默认邮箱地址
        setDefaultInvoiceMail(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 9) {
        var data = {
          data: {
            ownerType: 0, //开票主体类型 个人0 企业1
            ownerId: this.$store.getters.getUser.id, //开票主体id
            headType: 1, // 抬头类型
            invoiceType: SelectType, //发票类型 0普1专
            headName: val.LookUp, //抬头名称
            creditCode: val.unifyCode, // 信用代码
            legalPersonName: val.name, // 法人名称
            legalPersonIdNum: val.standing, // 法人身份证
            phone: val.phone,
            authCode: val.Code, // 验证码
            bankName: val.bank, //开户行
            bankAccount: val.number, // 开户行账号
            registerAddress: val.address, // 注册地
            telephone: val.FixedLine, // 固话
          },
        };
        // 添加抬头
        addInvoiceHead(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 10) {
        var data = {
          data: {
            id: this.rowId,
            ownerType: 0, //开票主体类型 个人0 企业1
            ownerId: this.$store.getters.getUser.id, //开票主体id
            headType: 1, // 抬头类型
            invoiceType: SelectType, //发票类型 0普1专
            headName: val.LookUp, //抬头名称
            creditCode: val.unifyCode, // 信用代码
            legalPersonName: val.name, // 法人名称
            legalPersonIdNum: val.standing, // 法人身份证
            phone: val.phone,
            authCode: val.Code, // 验证码
            bankName: val.bank, //开户行
            bankAccount: val.number, // 开户行账号
            registerAddress: val.address, // 注册地
            telephone: val.FixedLine, // 固话
          },
        };
        // 编辑抬头
        editInvoiceHead(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 12) {
        var data = {
          data: {
            id: this.rowId,
            ownerType: 0, //开票主体类型 个人0 企业1
            ownerId: this.$store.getters.getUser.id, //开票主体id
          },
        };
        // 设置默认抬头
        setDefaultInvoiceHead(data).then((res) => {
          this.resTips(res);
        });
      } else if (num == 11) {
        // var data = this.rowId;
        // 删除抬头
        deleteInvoiceHead({ data: this.rowId }).then((res) => {
          this.resTips(res);
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.box {
  display: flex;
  flex-direction: column;
  .main-body {
    width: 100%;
    min-height: 280px;
    box-sizing: border-box;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    margin-bottom: 30px;
    padding: 20px;
    .head {
      width: 100%;
      height: 35px;
      line-height: 35px;
      display: flex;
      .head-title {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #333333;
        font-weight: 400;
      }
      .head-remark {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #666666;
        font-weight: 400;
        margin-left: 10px;
      }
      .btn-body {
        flex: 1;
        display: flex;
        justify-content: flex-end;

        p {
          width: 90px;
          height: 35px;
          background: #409eff ;
          border-radius: 5px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          font-weight: 400;
          cursor: pointer;
        }
      }
    }
    //表格
    .table {
      width: 100%;
      min-height: 170px;
      margin-top: 30px;
      .header {
        width: 100%;
        height: 20px;
        line-height: 20px;
        margin-bottom: 20px;
        display: flex;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          overflow: hidden;
          width: 25%;
        }
      }
      .tabulation {
        width: 100%;
        height: 20px;
        line-height: 20px;
        margin-top: 25px;
        display: flex;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #666666;
          font-weight: 400;
          width: 25%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        div {
          display: flex;
          width: 25%;
          span {
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #ffffff;
            // color: #333333;
            text-align: center;
            font-weight: 400;
            margin-right: 10px;
            display: inline-block;
            border-radius: 5px;
            cursor: pointer;
          }
          .span-one {
            width: 45px;
            height: 20px;
            background: #409eff ;
          }
          .span-tw {
            width: 45px;
            height: 20px;
            background: #fe574a;
          }
          .span-th {
            width: 75px;
            height: 20px;
            background: #999999;
          }
        }
      }
      .tabulation:nth-child(1) {
        margin-top: 0px;
      }
    }
    //
    .quantity {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      height: 18px;
      margin-top: 23px;
      p {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        text-align: center;
        font-weight: 400;
      }
    }
  }
}
</style>
